/**
 * Copyright © 2025-2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { RouteObject } from "react-router-dom";

import { FlagSwitchGate } from "@/components/AppRouter/route-gates";
import { HOME_ANY_ROUTE } from "@/util/routing";

import DeprecatedHome from "./DeprecatedHome";
import Home from "./Home";

export const homeRoutes: RouteObject[] = [
  {
    path: HOME_ANY_ROUTE,
    element: (
      <FlagSwitchGate flag="enableHome" flagEnabled={<Home />} flagDisabled={<DeprecatedHome />} />
    ),
  },
];
